import { Stack } from "expo-router";

export default function SearchStack() {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerLargeTitle: true,
        headerTransparent: true,
        headerBlurEffect: "dark",
        headerLargeStyle: { backgroundColor: "transparent" },
        headerStyle: { backgroundColor: "transparent" },
        headerTintColor: "#fff",
      }}
    />
  );
}
